<template>
    <div>
        <megabit-base-dialog :show-dialog="true" :width="800">
            <template v-slot:body>
                <v-card dark>
                    <v-card-title>
                        <span class="font-weight-bold">Registrar Câmbio</span>
                        <span class="ml-2 font-weight-thin">(alt+r)</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form>
                        <v-row>
                            <v-col cols="6" sm="4" md="3" v-show="getCurrencies[0] ? getCurrencies[0].show : false" >
                                <v-text-field v-model="form.CAMBIO0" 
                                :hint="getCurrencies[0] ? getCurrencies[0].descricao : 'Moeda0'" persistent-hint>
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" md="3" v-show="getCurrencies[1] ? getCurrencies[1].show : false">
                                <v-text-field v-model="form.CAMBIO1"
                                :hint="getCurrencies[1] ? getCurrencies[1].descricao : 'Moeda1'" persistent-hint
                                ></v-text-field>
                            </v-col>                                                 
                            <v-col cols="6" sm="4" md="3" v-show="getCurrencies[2] ? getCurrencies[2].show : false">
                                <v-text-field v-model="form.CAMBIO2"
                                :hint="getCurrencies[2] ? getCurrencies[2].descricao : 'Moeda2'" persistent-hint
                                ></v-text-field>                                
                            </v-col>                                                                                     
                            <v-col cols="6" sm="4" md="3" v-show="getCurrencies[3] ? getCurrencies[3].show : false">
                                <v-text-field v-model="form.CAMBIO3"
                                :hint="getCurrencies[3] ? getCurrencies[3].descricao : 'Moeda3'" persistent-hint
                                ></v-text-field>                                
                            </v-col>    
                        </v-row>
                        <v-row>
                            <v-col cols="6" sm="4" md="3" v-show="getCurrencies[4] ? getCurrencies[4].show : false">
                                <v-text-field v-model="form.CAMBIO4"
                                :hint="getCurrencies[4] ? getCurrencies[4].descricao : 'Moeda4'" persistent-hint
                                ></v-text-field>                                
                            </v-col>
                            <v-col cols="6" sm="4" md="3" v-show="getCurrencies[5] ? getCurrencies[5].show : false">
                                <v-text-field v-model="form.CAMBIO5"
                                :hint="getCurrencies[5] ? getCurrencies[5].descricao : 'Moeda5'" persistent-hint
                                ></v-text-field>                                
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field type="text" v-model="form.DATA"
                                hint="Data" persistent-hint
                                disabled
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        </v-form>
                    </v-card-text>
                    <form-buttons @submitForm="validateForm()" @goBack="goBack()"/>

                </v-card>
            </template>
        </megabit-base-dialog>
    </div>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog';
import {mapState, mapActions} from 'vuex';
import {currencyMixin} from '@/mixins/object/currency/CurrencyMixin';
import FormButtons from '@/components/shared/base-buttons/FormButtons'

export default {
    mixins:[currencyMixin],
    components:{'megabit-base-dialog':BaseDialog, FormButtons},
    computed:{
        ...mapState('currencyModule',['currency']),
    },
    data:() => {
        return {
            form:{
                DATA: '',
                DATAHORA: '',
                CAMBIO0: 0,
                CAMBIO1: 0,
                CAMBIO2: 0,
                CAMBIO3: 0,
                CAMBIO4: 0,
                CAMBIO5: 0
            },
            formRules:{

            }
        }
    },
    methods:{
        ...mapActions({insertCurrency:'currencyModule/insertCurrency',
            showLoadingDialog: 'dialogModule/setShowLoadingDialog',
            setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage'}),
        async clearFormCurrencies() {
            Object.keys(this.form).forEach((key) => {
                if(key != 'DATA' && key != 'DATAHORA'){
                    console.log(this.form[key])
                    this.form[key] = this.form[key].toString().replace(',','.').replace(/[A-Z]/g, '').replace('$','').trim();
                    console.log(this.form[key])
                }
            })
        },
        goBack(){
            this.$router.push({name:'Cambio'})
        },
        async validateForm(){
            try{
                this.setLoadingDialogMessage('Inserindo cambio..');
                this.showLoadingDialog(true);

                await this.clearFormCurrencies();
                let response = await this.insertCurrency(this.form)
                this.$toasted.success(response);
                
            }catch(error){
                this.$toasted.error(error, {duration: null});
            }finally{
                this.showLoadingDialog(false);
            }
        },
        async getDate(delimiter = '-', withTime = false){
            let dateVar = new Date();
            let day = dateVar.getDate();
            let month = dateVar.getMonth() + 1;
            let year = dateVar.getFullYear();

            if(day.toString().length == 1)
                day = '0'.concat(day.toString())
            if(month.toString().length == 1)
                month = '0'.concat(month.toString())
    
            if(withTime){
                let time = dateVar.getHours() + ':' + dateVar.getMinutes() + ':' + dateVar.getSeconds()
                return `${year}${delimiter}${month}${delimiter}${day} ${time}` 
            }else{
                return `${year}${delimiter}${month}${delimiter}${day}`
            }
        },
        async mountData(){
            let lastCurrency = await this.currency[0];
            if(lastCurrency){
                this.form.DATA = await this.getDate('-',false);
                this.form.DATAHORA = await this.getDate('-',true) || '';
                this.form.CAMBIO0 = await this.formatCurrency(0, lastCurrency.CAMBIO0)
                this.form.CAMBIO1 = await this.formatCurrency(1, lastCurrency.CAMBIO1);
                this.form.CAMBIO2 = await this.formatCurrency(2, lastCurrency.CAMBIO2);
                this.form.CAMBIO3 = await this.formatCurrency(3, lastCurrency.CAMBIO3);
                this.form.CAMBIO4 = await this.formatCurrency(4, lastCurrency.CAMBIO4);
                this.form.CAMBIO5 = await this.formatCurrency(5, lastCurrency.CAMBIO5);
            }
        }
    },
    mounted(){
        this.mountData();
    },

}
</script>

<style>

</style>